import { Button } from "@/components/button";
import { useTrans } from "@/translations";

import React from "react";

import moment from "moment";
import { create } from "zustand";

type UsePdfPreview = {
  pdfPreviewOpen: boolean;
  setPdfPreviewOpen: (value: boolean) => void;
};

export const usePdfPreview = create<UsePdfPreview>((set) => ({
  pdfPreviewOpen: false,
  setPdfPreviewOpen: (_pdfPreviewOpen) =>
    set(() => ({ pdfPreviewOpen: _pdfPreviewOpen })),
}));

type Props = {
  generatePdf: () => void;
  close: () => void;
  view: React.JSX.Element;
};

export const PdfPreview: React.FC<Props> = ({
  generatePdf,
  close,
  view,
}: Props) => {
  const { t } = useTrans();
  return (
    <div className="bg-grey1 absolute top-0 right-0 bottom-0 left-0 z-20 w-full justify-center">
      <div className="relative m-auto my-4 flex max-w-[1500px] items-center justify-between px-4">
        <Button
          label="actions:close"
          className="float-right mx-4"
          onClick={close}
          color="secondary"
        />
        <h1 className="absolute left-1/2 -translate-x-1/2 transform text-2xl">
          {t("genericLabels:pdfPreview")}
        </h1>
        <Button
          label="actions:generatePdf"
          className="float-left mx-4"
          onClick={generatePdf}
        />
      </div>
      <div className="relative flex h-full w-full items-center justify-center overflow-scroll">
        <div
          className="bg-grey1 absolute top-0 max-h-[2500px] w-[1500px] pb-10"
          id="page-content"
        >
          <h1 className="align-center mb-4 w-full text-center text-2xl">
            Export {moment().format("YYYYMMDD")}
          </h1>
          <div className="light bg-grey1 justify-items-stretch p-8 pt-0 text-black">
            {view}
          </div>
        </div>
      </div>
    </div>
  );
};
